// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c04ef192","453":"9fdede36","667":"53f6844c","952":"84904a49"}[chunkId] + ".chunk.js";
};